import { Box, Typography, Collapse, Paper, CircularProgress } from "@mui/material";
import { useState } from "react";
import { UserRegisterForm } from "../../components/auth/UserRegisterForm";
import { ClientCreateForm } from "../../components/auth/ClientCreateForm";
import { useNavigate } from "react-router-dom";
import { TYPOGRAPHY_STYLES } from "../../styles/typographyStyles";
import { useSnackbar } from "notistack";

const TEXT = {
    title: { ...TYPOGRAPHY_STYLES.rubik, fontSize: 24, fontWeight: 700 },
    loaderText: { ...TYPOGRAPHY_STYLES.rubikSmall, fontWeight: 600, opacity: 0.9 },
} as const;

export default function Register() {
    const [step, setStep] = useState<"user" | "client">("user");
    const [userData, setUserData] = useState<{ nombre: string; apellido: string } | null>(null);

    const [registeringUser, setRegisteringUser] = useState(false);
    const [savingClient, setSavingClient] = useState(false);

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const showOverlay = registeringUser || savingClient;
    const overlayText = step === "user" ? "Creando tu cuenta" : "Guardando cliente";

    return (
        <Box sx={{ maxWidth: 420, mx: "auto", mt: 4, mb: 10 }}>
            <Paper
                sx={{
                    p: 3,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {showOverlay && (
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            zIndex: 10,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            bgcolor: "rgba(255,255,255,0.75)",
                            backdropFilter: "blur(1px)",
                        }}
                    >
                        <CircularProgress size={28} />
                        <Typography sx={TEXT.loaderText}>{overlayText}</Typography>
                    </Box>
                )}

                <Typography sx={{ ...TEXT.title, mb: 3 }}>Crear cuenta</Typography>

                {/* PASO 1 */}
                <Collapse in={step === "user"} unmountOnExit mountOnEnter>
                    <UserRegisterForm
                        onLoadingChange={setRegisteringUser}
                        onSuccess={(u) => {
                            enqueueSnackbar("Usuario registrado correctamente", { variant: "success" });

                            setUserData(u);
                            setStep("client");
                        }}
                    />
                </Collapse>

                {/* PASO 2 */}
                <Collapse in={step === "client"} unmountOnExit mountOnEnter>
                    <ClientCreateForm
                        prefillUser={userData ?? undefined}
                        onLoadingChange={setSavingClient}
                        onSuccess={() => {
                            navigate("/", {
                                state: {
                                    snackbar: {
                                        message: "Usuario registrado y cliente creado correctamente",
                                        variant: "success",
                                    },
                                },
                            });
                        }}
                    />
                </Collapse>
            </Paper>
        </Box>
    );
}














